import {
  TransparencyBtnIcon,
  InfoBtnIcon,
  InfoDisabledBtnIcon,
  MetadataBtnIcon,
  StylesBtnIcon,
  CloseBtnIcon,
  ExportBtnIcon,
  AddElementBtnIcon,
  FilterBtnIcon,
  TableBtnIcon,
  StatsBtnIcon,
  ZoomBtnIcon
} from './CapaLlegendaFooterIconsElement';

export const getTransparencyIcon = (fontSizeEnabled, layer) => (
  <TransparencyBtnIcon fontSizeEnabled={fontSizeEnabled} class={`${!layer.isTransPopUpOpen() ? 'transparencia-btn' : ''}`}>
    <path
      class={`${!layer.isTransPopUpOpen() ? 'transparencia-btn' : ''}`}
      d="M19 13V11H21V13H19M21 9V7H19V9H21M21 3H19V5H21V3M17 15H19V13H17V15M21 17V15H19V17H21M13 17V15H15V13H13V11H15V9H13V7H15V5H13V3H3V21H13V19H15V17H13M15 21H17V19H15V21M17 3H15V5H17V3M17 11H19V9H17V11M15 17H17V15H15V17M17 19H19V17H17V19M21 21V19H19V21H21M15 9H17V7H15V9M15 13H17V11H15V13M17 5V7H19V5H17Z"
    />
  </TransparencyBtnIcon>
);

export const getInfoIcon = (fontSizeEnabled) => (
  <InfoBtnIcon fontSizeEnabled={fontSizeEnabled}>
    <g xmlns="http://www.w3.org/2000/svg">
      <path d="M255.8,482.6c-12.6,0-24.3-5.7-32.1-15.6L177,407.7l-82-0.1c-40.3,0-73.2-32.8-73.2-73.2V95.6c0-40.4,32.8-73.2,73.2-73.2   h322c40.4,0,73.2,32.8,73.2,73.2v240.9c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3V95.6c0-20.2-16.4-36.6-36.6-36.6H95   c-20.2,0-36.6,16.4-36.6,36.6v238.8c0,20.2,16.4,36.6,36.6,36.6l90.9,0.1c5.6,0,10.9,2.6,14.4,7l52.3,66.4c1.1,1.4,2.4,1.6,3.3,1.6   l0,0c0.9,0,2.2-0.3,3.3-1.6l0.1-0.1l51.9-66.3c3.5-4.4,8.8-7,14.4-7H417c20.2,0,36.6-16.4,36.6-36.6c0-10.1,8.2-18.3,18.3-18.3   s18.3,8.2,18.3,18.3c0,40.4-32.8,73.2-73.2,73.2h-82.6L288,466.9C280.3,476.9,268.6,482.7,255.8,482.6   C255.9,482.6,255.9,482.6,255.8,482.6z M276.4,316.1V206c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4v110.1   c0,11.3,9.1,20.4,20.4,20.4S276.4,327.4,276.4,316.1z M255.7,108c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6   S269.3,108,255.7,108z" />
    </g>
  </InfoBtnIcon>
);

export const getInfoDisabledIcon = (fontSizeEnabled) => (
  <InfoDisabledBtnIcon fontSizeEnabled={fontSizeEnabled}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M252.8,482.6c-12.6,0-24.3-5.7-32.1-15.6L174,407.7l-82-0.1c-40.3,0-73.2-32.8-73.2-73.2V95.6c0-40.4,32.8-73.2,73.2-73.2  h322c40.4,0,73.2,32.8,73.2,73.2v240.9c0,10.1-8.2,18.3-18.3,18.3s-18.3-8.2-18.3-18.3V95.6c0-20.2-16.4-36.6-36.6-36.6H92  c-20.2,0-36.6,16.4-36.6,36.6v238.8c0,20.2,16.4,36.6,36.6,36.6l90.9,0.1c5.6,0,10.9,2.6,14.4,7l52.3,66.4c1.1,1.4,2.4,1.6,3.3,1.6  l0,0c0.9,0,2.2-0.3,3.3-1.6l0.1-0.1l51.9-66.3c3.5-4.4,8.8-7,14.4-7H414c20.2,0,36.6-16.4,36.6-36.6c0-10.1,8.2-18.3,18.3-18.3  s18.3,8.2,18.3,18.3c0,40.4-32.8,73.2-73.2,73.2h-82.6L285,466.9C277.3,476.9,265.6,482.7,252.8,482.6  C252.9,482.6,252.9,482.6,252.8,482.6z M271.3,316.1V206c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4v110.1  c0,11.3,9.1,20.4,20.4,20.4C262.2,336.5,271.3,327.4,271.3,316.1z M250.6,108c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6  c13.6,0,24.6-11,24.6-24.6S264.2,108,250.6,108z"
    />
    <g xmlns="http://www.w3.org/2000/svg">
      <line x1="45" y1="277.9" x2="36.6" y2="277.9" />
      <path d="M399.1,445.6c-81-80.1-292.4-292.8-373.9-374.2c-11.1-11.1-12-28.3-0.8-39.5s28.8-10.7,39.8,0.5   c81.6,82,293.3,293,373.8,374.3C462.4,433.4,425.9,470.2,399.1,445.6L399.1,445.6z" />
    </g>
  </InfoDisabledBtnIcon>
);

export const getMetadataIcon = (fontSizeEnabled, layer) => (
  <MetadataBtnIcon fontSizeEnabled={fontSizeEnabled} class={`${layer.hasMetadata() && !layer.isTemporal() ? 'metadata-btn' : ''}`}>
    <g>
      <path
        d="M472.3,124.4l-128-120c-3-2.8-7-4.4-11.3-4.4H109C82.5,0,61,20.2,61,45v422c0,24.8,21.5,45,48,45h320c26.5,0,48-20.2,48-45
		      V135C477,130.9,475.2,127.1,472.3,124.4z M349,51.2l73.4,68.8h-73.3 M429,482H109c-8.9,0-16-6.7-16-15V45c0-8.3,7.1-15,16-15h208
		      v75c0,47.8-1.5,45,45.6,45H445v317C445,475.3,437.9,482,429,482z"
      />
      <path d="M365,183H173c-8.9,0-16,6.7-16,15s7.1,15,16,15h192c8.9,0,16-6.7,16-15S373.9,183,365,183z" />
      <path d="M365,243H173c-8.9,0-16,6.7-16,15c0,8.3,7.1,15,16,15h192c8.9,0,16-6.7,16-15S373.9,243,365,243z" />
      <path d="M365,303H173c-8.9,0-16,6.7-16,15s7.1,15,16,15h192c8.9,0,16-6.7,16-15S373.9,303,365,303z" />
      <path d="M301,363H173c-8.9,0-16,6.7-16,15s7.1,15,16,15h128c8.9,0,16-6.7,16-15S309.9,363,301,363z" />
    </g>
  </MetadataBtnIcon>
);

export const getStylesIcon = (fontSizeEnabled) => (
  <StylesBtnIcon fontSizeEnabled={fontSizeEnabled}>
    <g>
      <path d="m211 363.086c0 24.813 20.187 45 45 45s45-20.187 45-45-20.187-45-45-45-45 20.186-45 45zm30 0c0-8.271 6.729-15 15-15s15 6.729 15 15-6.729 15-15 15-15-6.729-15-15z" />
      <path d="m399.098 235.598c24.813 0 45-20.187 45-45s-20.187-45-45-45-45 20.187-45 45 20.187 45 45 45zm0-30c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.728 15-15 15z" />
      <path d="m331.524 318.624c0 24.813 20.187 45 45 45s45-20.187 45-45-20.187-45-45-45-45 20.186-45 45zm30 0c0-8.271 6.729-15 15-15s15 6.729 15 15-6.729 15-15 15-15-6.729-15-15z" />
      <path d="m8.022 508.691c14.605 10.227 32.49-5.734 42.098-14.309 11.761-10.496 26.661-25.999 44.283-46.077 17.911-20.406 37.646-44.482 56.768-69.111 1.417 11.667 4.82 23.098 10.208 33.844 13.584 27.087 38.496 46.125 68.349 52.233 2.106.432 4.263.842 6.404 1.22 13.783 2.43 27.596 3.631 41.306 3.632 47.778 0 94.337-14.585 134.291-42.562 51.419-36.003 85.739-89.876 96.64-151.693 10.899-61.817-2.926-124.179-38.93-175.598s-89.876-85.739-151.693-96.64c-61.813-10.897-124.179 2.925-175.598 38.93-51.419 36.003-85.739 89.876-96.64 151.693l-.454 2.597c-2.417 13.815 2.237 27.706 12.45 37.155 10.673 9.875 25.634 13.567 40.02 9.883 9.255-2.372 19.114-2.238 28.512.381 3.397.948 6.655 2.241 9.776 3.833-4.085 5.59-8.299 11.484-12.654 17.703-30.159 43.072-63.854 97.123-87.936 141.062-12.84 23.427-22.312 42.729-28.153 57.371-4.771 11.962-13.652 34.226.953 44.453zm183.165-183.199c1.931-2.712 3.831-5.402 5.695-8.065 25.513-36.436 42.408-64.736 51.336-86.037 14.891-2.115 28.281-10.233 37.157-22.909 39.641-56.613-11.587-133.397-13.787-136.637-3.28-4.833-9.067-7.322-14.831-6.379s-10.456 5.144-12.027 10.769c-2.056 7.33-9.166 28.626-17.229 38.914-3.987 5.088-6.891 7.002-10.911 9.651-5.712 3.763-12.821 8.448-21.322 20.59-8.875 12.675-11.924 28.035-8.819 42.75-9.506 8.785-20.223 20.676-32.3 35.845-6.311-3.746-13.074-6.664-20.055-8.61-14.455-4.031-29.677-4.218-44.017-.544-4.473 1.146-9.036.085-12.198-2.843-1.612-1.491-4.182-4.77-3.272-9.967l.45-2.577c9.505-53.904 39.444-100.899 84.299-132.307s99.25-43.469 153.182-33.959c111.319 19.628 185.916 126.163 166.287 237.483s-126.171 185.922-237.485 166.286c-1.873-.33-3.755-.688-5.596-1.065-21.091-4.315-37.977-17.204-47.548-36.291-10.28-20.498-10.359-44.634-.217-66.218 1.179-2.505 2.251-5.15 3.208-7.88zm28.655-162.897c5.217-7.45 8.588-9.672 13.254-12.747 4.906-3.233 11.01-7.256 18.017-16.195 3.795-4.843 7.194-10.716 10.135-16.704 8.724 21.709 15.389 51.706-.448 74.324-4.286 6.121-10.893 9.893-18.175 10.552l-26.482-18.543c-1.871-7.068-.587-14.566 3.699-20.687zm-179.146 299.434c5.571-12.094 14.035-28.794 26.889-51.645 23.134-41.121 53.095-88.737 80.148-127.372 23.088-32.973 42.247-56.782 57.123-71.01l14.643 10.253c-8.283 18.847-24.104 44.994-47.191 77.965-27.053 38.635-61.55 83.076-92.279 118.879-17.076 19.893-29.874 33.558-39.333 42.93z" />
    </g>
  </StylesBtnIcon>
);

export const getAddElementIcon = (fontSizeEnabled) => (
  <AddElementBtnIcon fontSizeEnabled={fontSizeEnabled} class="edit-btn" viewBox="0 0 6.3499999 6.3500002">
    <g xmlns="http://www.w3.org/2000/svg" id="layer1" transform="translate(0 -290.65)">
      <path
        id="circle2439"
        d="m3.1739792 290.85151c-1.6389501 0-2.9724285 1.33555-2.9724285 2.9745s1.3334784 2.97243 2.9724285 2.97243c1.638949 0 2.9750121-1.33348 2.9750121-2.97243s-1.3360631-2.9745-2.9750121-2.9745zm0 .52917c1.352967 0 2.4453287 1.09236 2.4453287 2.44533 0 1.35296-1.0923617 2.44326-2.4453287 2.44326s-2.4432618-1.0903-2.4432618-2.44326c0-1.35297 1.0902948-2.44533 2.4432618-2.44533zm-.00362 1.11724a.26460982.26460982 0 0 0 -.2599331.26924v.79323h-.7927133a.2646485.2646485 0 0 0 0 .52917h.7927165v.79271a.2648417.2648417 0 1 0 .5296834 0v-.79271h.7927166a.2646485.2646485 0 0 0 0-.52917h-.7927166v-.79323a.26460982.26460982 0 0 0 -.2697509-.26924z"
        font-variant-ligatures="normal"
        font-variant-position="normal"
        font-variant-caps="normal"
        font-variant-numeric="normal"
        font-variant-alternates="normal"
        font-feature-settings="normal"
        text-indent="0"
        text-align="start"
        text-decoration-line="none"
        text-decoration-style="solid"
        text-decoration-color="rgb(0,0,0)"
        text-transform="none"
        text-orientation="mixed"
        white-space="normal"
        shape-padding="0"
        isolation="auto"
        mix-blend-mode="normal"
        solid-color="rgb(0,0,0)"
        solid-opacity="1"
        vector-effect="none"
      />
    </g>
  </AddElementBtnIcon>
);

export const getFilterIcon = (fontSizeEnabled) => (
  <FilterBtnIcon fontSizeEnabled={fontSizeEnabled} class="filter-btn" viewBox="0 0 24 24">
    <g>
      <path d="m9 22.5c-.2 0-.4-.1-.5-.1-.3-.2-.5-.6-.5-.9v-9.6l-7.7-8.7c-.4-.4-.3-1 .1-1.4.1-.2.4-.3.6-.3h22c.6 0 1 .4 1 1 0 .2-.1.5-.2.7l-7.8 8.7v6.6c0 .4-.2.7-.6.9l-6 3c-.1.1-.2.1-.4.1zm-5.8-19 6.5 7.3c.2.2.3.5.3.7v8.4l4-2v-6.4c0-.2.1-.5.3-.7l6.5-7.3z"></path>
    </g>
  </FilterBtnIcon>
);

export const getTableIcon = (fontSizeEnabled) => (
  <TableBtnIcon fontSizeEnabled={fontSizeEnabled} class="table-btn" viewBox="0 0 24 24">
    <path d="M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z" />
  </TableBtnIcon>
);

export const getStatsIcon = (fontSizeEnabled) => (
  <StatsBtnIcon fontSizeEnabled={fontSizeEnabled} class="table-btn" viewBox="0 0 512 512">
    <g>
      <g>
        <path d="M226,157.9h-60c-8.3,0-15,6.7-15,15v290h90v-290C241,164.6,234.3,157.9,226,157.9z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M346,212.9h-60c-8.3,0-15,6.7-15,15v235h90v-235C361,219.6,354.3,212.9,346,212.9z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M466,41h-60c-8.3,0-15,6.7-15,15v406.9h90V56C481,47.7,474.3,41,466,41z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M106,290.3H46c-8.3,0-15,6.7-15,15v157.6h90V305.3C121,297,114.3,290.3,106,290.3z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M497,482c-67,0-97.7,0-109.9,0c-5.5,0-7.5,0-7.5,0c-22.1,0-104.4,0-364.6,0c-8.3,0-15,6.7-15,15s6.7,15,15,15    c181.5,0,312.4,0,482,0c8.3,0,15-6.7,15-15S505.3,482,497,482z" />
      </g>
    </g>
  </StatsBtnIcon>
);

export const getExportIcon = (fontSizeEnabled, layer) => (
  <ExportBtnIcon fontSizeEnabled={fontSizeEnabled} class={`${!layer.isExternal() && !layer.isExportOpen() ? 'export-btn' : ''}`}>
    <g id="XMLID_26_">
      <path
        id="XMLID_27_"
        d="M243.1,378.2c0.4,0.4,0.9,0.8,1.3,1.2c0.2,0.2,0.4,0.3,0.6,0.5c0.3,0.2,0.5,0.4,0.8,0.6
 c0.3,0.2,0.5,0.3,0.8,0.5c0.2,0.1,0.5,0.3,0.7,0.4c0.3,0.1,0.6,0.3,0.8,0.4c0.3,0.1,0.5,0.3,0.8,0.4c0.3,0.1,0.5,0.2,0.8,0.3
 c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.1,0.8,0.2c0.3,0.1,0.6,0.2,0.9,0.2c0.3,0.1,0.6,0.1,1,0.1c0.3,0,0.5,0.1,0.8,0.1
 c0.6,0.1,1.2,0.1,1.8,0.1c0.6,0,1.2,0,1.8-0.1c0.3,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,1-0.1c0.3-0.1,0.6-0.1,0.9-0.2
 c0.3-0.1,0.5-0.1,0.8-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5-0.2,0.8-0.3c0.3-0.1,0.5-0.2,0.8-0.4c0.3-0.1,0.5-0.3,0.8-0.4
 c0.3-0.1,0.5-0.3,0.7-0.4c0.3-0.2,0.5-0.3,0.8-0.5c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.4-0.3,0.7-0.5c0.4-0.4,0.9-0.7,1.3-1.2
 c0,0,0,0,0.1-0.1l85.1-85c7.1-7.1,7.1-18.7,0-25.8c-7.1-7.1-18.7-7.1-25.8,0l-53.9,53.9V73.7c0-10.1-8.2-18.2-18.2-18.2
 c-10.1,0-18.2,8.2-18.2,18.2v247.6l-53.9-53.9c-7.1-7.1-18.7-7.1-25.8,0c-7.1,7.1-7.1,18.7,0,25.8L243.1,378.2z"></path>
      <path
        id="XMLID_28_"
        d="M438.3,420H73.7c-10.1,0-18.2,8.2-18.2,18.2s8.2,18.2,18.2,18.2h364.5c10.1,0,18.2-8.2,18.2-18.2
 S448.3,420,438.3,420z"></path>
    </g>
  </ExportBtnIcon>
);

export const getCloseIcon = (fontSizeEnabled) => (
  <CloseBtnIcon fontSizeEnabled={fontSizeEnabled} class="close-btn" viewBox="0 0 330 330">
    <g>
      <path
        d="M315,0.001H15c-8.284,0-15,6.716-15,15v299.998c0,8.284,6.716,15,15,15h300c8.284,0,15-6.716,15-15V15.001
                            C330,6.717,323.284,0.001,315,0.001z M300,299.999H30V30.001h270V299.999z"
      />
      <path
        d="M84.394,245.606C87.323,248.536,91.161,250,95,250c3.838,0,7.678-1.465,10.606-4.394l59.393-59.392l59.391,59.392
                        c2.93,2.93,6.768,4.394,10.607,4.394c3.838,0,7.678-1.465,10.606-4.394c5.858-5.857,5.858-15.355,0-21.213l-59.391-59.393
                        l59.394-59.393c5.858-5.857,5.858-15.355,0-21.213c-5.857-5.858-15.354-5.858-21.213,0L165,143.788l-59.393-59.395
                        c-5.859-5.858-15.355-5.858-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l59.393,59.395l-59.393,59.393
                        C78.536,230.251,78.536,239.749,84.394,245.606z"
      />
    </g>
  </CloseBtnIcon>
);

export const getZoomIcon = (fontSizeEnabled, layer, isZoomToLayerHover, movilZoomHover) => (
  <ZoomBtnIcon
    fontSizeEnabled={fontSizeEnabled}
    class="zoom-btn"
    viewBox="0 0 330 330"
    layer={layer}
    isZoomToLayerHover={isZoomToLayerHover}
    movilZoomHover={movilZoomHover}>
    <g>
      <path d="M423.1,113.6c0-10.4-8.4-18.7-18.8-18.8h-98.1c-10.4-0.1-18.8,8.2-18.9,18.6s8.2,18.8,18.6,18.9   c0.1,0,0.3,0,0.4,0h52.9l-69.8,69.8c-7.3,7.3-7.3,19.2,0,26.5s19.2,7.3,26.5,0l0,0l69.8-69.8v52.9c0.1,10.4,8.6,18.7,18.9,18.6   c10.2-0.1,18.5-8.4,18.6-18.6v-98.1H423.1z" />
      <path d="M100.8,398.4c0,10.4,8.4,18.7,18.8,18.8h98.1c10.4,0.1,18.8-8.2,18.9-18.6s-8.2-18.8-18.6-18.9   c-0.1,0-0.3,0-0.4,0h-52.9l69.8-69.8c7.3-7.3,7.3-19.2,0-26.5s-19.2-7.3-26.5,0l0,0l-69.8,69.8v-52.9c-0.1-10.4-8.6-18.7-18.9-18.6   c-10.2,0.1-18.5,8.4-18.6,18.6L100.8,398.4L100.8,398.4z" />
      <g>
        <path d="M196.8,19.1c0-8.9,7.2-16.1,16.1-16.1h86.1c8.9,0,16.1,7.2,16.1,16.1s-7.2,16.1-16.1,16.1h-86.1    C204,35.3,196.8,28.1,196.8,19.1z" />
        <path d="M196.8,492.9c0-8.9,7.2-16.1,16.1-16.1h86.1c8.9,0,16.1,7.2,16.1,16.1S308,509,299.1,509h-86.1    C204,509,196.8,501.8,196.8,492.9z" />
        <path d="M390.6,19.1c0-8.9,7.2-16.1,16.1-16.1h64.6c10,0,19.6,4,26.6,11s11,16.7,11,26.6v64.6    c0,8.9-7.2,16.1-16.1,16.1s-16.1-7.2-16.1-16.1V40.7c0-1.4-0.6-2.8-1.6-3.8c-1-1-2.4-1.6-3.8-1.6h-64.6    C397.8,35.3,390.6,28.1,390.6,19.1z" />
        <path d="M492.9,196.8c8.9,0,16.1,7.2,16.1,16.1v86.1c0,8.9-7.2,16.1-16.1,16.1s-16.1-7.2-16.1-16.1v-86.1    C476.7,204,483.9,196.8,492.9,196.8z" />
        <path d="M492.9,390.6c8.9,0,16.1,7.2,16.1,16.1v64.6c0,10-4,19.6-11,26.6s-16.7,11-26.6,11h-64.6    c-8.9,0-16.1-7.2-16.1-16.1s7.2-16.1,16.1-16.1h64.6c1.4,0,2.8-0.6,3.8-1.6c1-1,1.6-2.4,1.6-3.8v-64.6    C476.7,397.8,483.9,390.6,492.9,390.6z" />
        <path d="M19.1,196.8c8.9,0,16.1,7.2,16.1,16.1v86.1c0,8.9-7.2,16.1-16.1,16.1S3,308,3,299.1v-86.1    C3,204,10.2,196.8,19.1,196.8z" />
        <path d="M19.1,390.6c8.9,0,16.1,7.2,16.1,16.1v64.6c0,1.4,0.6,2.8,1.6,3.8c1,1,2.4,1.6,3.8,1.6h64.6    c8.9,0,16.1,7.2,16.1,16.1s-7.2,16.1-16.1,16.1H40.7c-10,0-19.6-4-26.6-11S3,481.3,3,471.3v-64.6C3,397.8,10.2,390.6,19.1,390.6z" />
        <path d="M14,14C21.1,7,30.7,3,40.7,3h64.6c8.9,0,16.1,7.2,16.1,16.1s-7.2,16.1-16.1,16.1H40.7c-1.4,0-2.8,0.6-3.8,1.6    c-1,1-1.6,2.4-1.6,3.8v64.6c0,8.9-7.2,16.1-16.1,16.1S3,114.2,3,105.3V40.7C3,30.7,7,21.1,14,14z" />
      </g>
    </g>
  </ZoomBtnIcon>
);
